<template>
    <v-layout align-center justify-center class="dashboard-index">
        <img src="/static/img/logo.png" alt="" style="max-width: 100%"/>
    </v-layout>
</template>

<script>
    export default {
        name: 'blankIndex'
    }
</script>

<style lang="scss">
    @import "../../assets/styles/colors";

    .dashboard {
        &-index {
            background-color: rgba($asideBg, 0.03);
        }
    }
</style>
